import { useState } from "react"
import { useFetch } from "../hooks/useFetch";

import '../styles/Dictionary.css'

import Search from '../img/search.png'

export default function Dictionary() {

  const [word , setWord] = useState('')
  const [inputTxt , setInputTxt] = useState('')

  const {data : wordInfo } = useFetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`)

  const handleSubmit = (e) => {
    e.preventDefault();
    setWord(inputTxt)
    setInputTxt('')
  }
  if(wordInfo) {
    console.log(wordInfo[0])
  }
  return (
    <div className="Dictionary">
      <h1>Dictionary</h1>
      <div className="Dictionary-container">
          <form onSubmit={(e)=> handleSubmit(e) } className='SearchBar'>
            <input type="text" placeholder="Search..." value={inputTxt}
              onChange={(e)=> setInputTxt(e.target.value.trim())}/>
            
            <button type='submit'>
              <img src={Search} alt=""  />
            </button>
        </form>
        {wordInfo && 
          <div className="Dic-Word">
              <h1>{wordInfo[0].word}</h1>
              {wordInfo[0].meanings.map((meaning , index)=> {
                return (
                  <div key={index} className='Dic-word-info'>
                    <p className="parts-of-speech">[{meaning.partOfSpeech}]</p>  
                    <p className="def">{meaning.definitions[0].definition}</p>
                    {meaning.definitions[0].example && <p className="example">"{meaning.definitions[0].example}"</p>}
                    <p className="antonyms">
                      {meaning.antonyms.length > 0 && <span>Antonyms : </span>}
                      {meaning.antonyms && 
                        meaning.antonyms.map((a,i) => {
                          return <span className="antonym" key={i}>{a}</span>
                        })
                      }
                    </p>
                      
                    <p className="antonyms">
                      {meaning.synonyms.length > 0 && <span>Synonyms : </span>}
                      {meaning.synonyms && meaning.synonyms.map((s,i) => {
                            return <span className="synonym" key={i}>{s} </span>
                          })
                      }
                    </p>
                </div>)
              })}
          </div>} 
      </div>
      

    </div>
  )
}

/*   <audio
          style={{ backgroundColor: "#fff", borderRadius: 10 }}
          src={meanings[0].phonetics[0] && meanings[0].phonetics[0].audio}
          controls
        >
          Your browser does not support the audio element.
        </audio> */